<template>
  <div class="Answer" v-show="token">
    <div class="conter">
      <div class="banner"></div>
    </div>
    <div class="tap">
      <div class="swiper-container swiper-no-swiping" style="width: 100%;height: 100%;">
          <div class="swiper-wrapper" style="width: 100%;height: 100% !important;">
<!--              1-->
              <div class="swiper-slide" v-for="question in questionArr">
                <div style="font-size: .24rem; margin-bottom: .15rem;">完成{{question.question_id}}/23题</div>
                <div class="title1" style="display: flex;">
                  <div class="biaoti"style="margin-right: .1rem;">{{question.question_id}}</div>
                  <div style="flex: 1;">{{question.question_title}}</div>
                </div>
                <ul class="xuanze">
                  <li v-for="option  in question.question_option" :class="{active:option.option_key == submitData[question.question_id]}"
                      v-on:click="saveAnswer(question.question_id,option.option_key)">
                    <button type="button">{{option.option_key}}</button>
                    <span>{{option.option_value}}</span>
                  </li>
                </ul>
              </div>
          </div>
        <div class="swiper-pagination"></div>
        <button class="swiper-button-next" @click="next()" v-show="play" style="margin-bottom: 2rem">下一题</button>
        <button class="submit" v-show="play_1" @click="submitQuestion()" style="margin-bottom: 2rem">提交</button>
      </div>
    </div>
    <bar></bar>
  </div>
</template>

<script>
  import Swiper from "../../../config/swiper-3.4.2.min.js"
  import http from "../../lib/http";
  import bar from "../tab-bar/bar.vue";
  export default {
    name: 'CepingIndex',
    beforeCreate() {

    },
    data() {
      return {
        num:1,
        play:true,
        play_1:false,
        questionArr:[],
        totalNum:23,
        submitData:{},
        initialSlide:true,
        token:false
      }
    },
    components:{
        bar
    },
    mounted() {
      let self = this;

      this.swiper = new Swiper('.swiper-container', {
        nextButton: '.swiper-button-next',
        pagination: '.swiper-pagination',
        paginationType: 'progress',
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoHeight: true,
          onSlideChangeEnd: function(swiper){
              self.swiper.lockSwipes();
          }
      });
      this.swiper.lockSwipes();
      this.getQuestion();
    },
    methods:{
      next(){
          if(!this.submitData[this.num]){
              alert("请选择答案");
              return false;
          }
        this.swiper.unlockSwipes();
        this.num ++;
        if(this.num >= this.totalNum){
           this.play = false;
           this.play_1 = true;
        }

      },
        getScore(){
            //获取用户的证书信息
            const self = this;
            http({
                method: "post",
                url: "/org/evaluation/get-score",
                data: ""
            }).then(function(res){
                if(res.code == 2222603){
                    self.getCert();
                }else{
                    self.$router.push('/cp-result');
                }
            }).catch(function(err){

            });
        },

        getCert(){
            //获取用户的证书信息
            const self = this;
            http({
                method: "post",
                url: "/org/evaluation/get-cert",
                data: ""
            }).then(function(res){
                if(Object.keys(res.data).length !=0){
                    self.$router.push('/cp-result');
                }else{
                    self.reload();
                }
            }).catch(function(err){

            });
        },

      getQuestion(){
          this.getScore();
          let self = this;
          http({
              method: "post",
              url: "/org/evaluation/get-question",
              data: ""
          }).then(function(res){
                if(res.code ==0){
                    self.questionArr = res.data;
                }
          }).catch(function(err){

          });
      },
      saveAnswer(questionId,optionKey){
          this.$set(this.submitData, questionId, optionKey)
      },
      submitQuestion(){
          let self = this;
          http({
              method: "post",
              url: "/org/evaluation/submit",
              data: "data="+JSON.stringify(this.submitData)
          }).then(function(res){
              if(res.code ==0){
                  self.$router.push("/cp-result");
              }else{
                  alert(res.mess);
              }
          }).catch(function(err){

          });
      },
    },
    created() {
        var isToken = document.cookie.split(';');
        if(isToken!=""){
            this.token = true;
        }
    }
  }
</script>

<style scoped>
  @import "../../css/swiper.css";
  .active {
      border: 1px solid #096e27 !important;
  }
  .conter {
    width: 100%;
    height: 3.41rem;
    position: relative;
    font-size: .28rem;
  }

  .banner {
    width: 100%;
    height: 3.41rem;
    background-image: url(//images.jinku.com/newjk/org/images/1_H5_01.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: .29rem;
  }

  .tap {
    margin: 0 .39rem 0 .42rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ceping/index.vue